// This low-resolution alpha mask selects annotations only. It never changes
// precipitation measurements, colours or the radar image shown on the map.
function mercator(lat, lon) {
 const s=Math.max(-.9999,Math.min(.9999,Math.sin(lat*Math.PI/180)));
 return {x:lon/360+.5,y:.5-Math.log((1+s)/(1-s))/(4*Math.PI)};
}
export function radarCoveredPlaces(places,frame,mask) {
 if(!mask||!frame?.bounds)return places; // Image unavailable: keep names readable.
 const [[south,west],[north,east]]=frame.bounds;
 const sw=mercator(south,west),ne=mercator(north,east);
 if(!(ne.x>sw.x&&sw.y>ne.y))return places;
 return places.filter(place=>{
  const p=mercator(place.lat,place.lon),fx=(p.x-sw.x)/(ne.x-sw.x),fy=(p.y-ne.y)/(sw.y-ne.y);
  if(fx<0||fx>1||fy<0||fy>1)return false;
  const x=Math.round(fx*(mask.width-1)),y=Math.round(fy*(mask.height-1));
  // A one-pixel margin avoids flickering names along smoothed echo edges.
  for(let dy=-1;dy<=1;dy++)for(let dx=-1;dx<=1;dx++) {
   const xx=x+dx,yy=y+dy;
   if(xx>=0&&xx<mask.width&&yy>=0&&yy<mask.height&&mask.data[(yy*mask.width+xx)*4+3]>=128)return true;
  }
  return false;
 });
}
export function createRadarLabelSampler() {
 const cache=new Map();
 const read=frame=>{
  if(!frame?.url||frame.tiles)return Promise.resolve(null);
  if(cache.has(frame.key))return cache.get(frame.key).promise;
  const item={};
  item.promise=new Promise(resolve=>{
   const image=new Image();let finished=false;
   const finish=value=>{if(finished)return;finished=true;clearTimeout(timer);image.onload=image.onerror=null;image.src='';resolve(value);};
   const timer=setTimeout(()=>finish(null),8000);
   item.cancel=()=>finish(null);image.crossOrigin='anonymous';
   image.onerror=()=>finish(null);
   image.onload=()=>{
    try{
     const canvas=document.createElement('canvas');canvas.width=canvas.height=256;
     const context=canvas.getContext('2d',{willReadFrequently:true});
     context.drawImage(image,0,0,256,256);finish(context.getImageData(0,0,256,256));
    }catch{finish(null);}
   };
   image.src=frame.url;
  });
  cache.set(frame.key,item);
  while(cache.size>3){const key=cache.keys().next().value;cache.get(key).cancel();cache.delete(key);}
  return item.promise;
 };
 read.clear=()=>{for(const item of cache.values())item.cancel();cache.clear();};
 return read;
}
